module.exports = __webpack_public_path__ + "img/safe.27ac4508.svg";